module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/PENAyn/tc-custom/9781454936534.jpg?1720281442779",
      "alt": "This image is the cover for the book 1-2-3 Calligraphy!, Calligraphy Basics"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("1-2-3 Calligraphy!, Calligraphy Basics\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The author of "), _c('i', [_vm._v("Calligraphy for Kids")]), _vm._v(" returns with a new volume of alphabets and creative projects for artists of all ages and skill levels.")]), _c('br'), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v("With "), _c('i', [_vm._v("1-2-3 Calligraphy")]), _vm._v(", children can make eye-catching signs, design their own personal stationery, address colorful envelopes in elegant script, and create pictures and other decorations to hang on the wall. Inside this guide, budding calligraphers will find new alphabets—and new ways to render the alphabets they already know—as well as fresh techniques and projects. "), _c('br'), _c('br'), _vm._v("Author and calligrapher Eleanor Winters starts with a review of calligraphy basics, including the rules of layout and fundamental skills. She also discusses techniques such as changing the weight of italic letters and forming italic capitals. And with an introduction to both Swing and Modern Gothic handwriting, "), _c('i', [_vm._v("1-2-3 Calligraphy")]), _vm._v(" is the ultimate guide to this endlessly creative artform.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Eleanor Winters\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Eleanor Winters lives in Brooklyn and Paris. In addition to her work as a calligrapher, she’s also an artist who’s been featured in Tribeca’s Franklin 54 Studio.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0